import type { FC } from 'react';
import { useState } from 'react';

import { Box, Typography, useTheme } from '@mui/material';

import { ArrowDownSmallIcon } from '@setup/svg-icons/svg-icons';
import { PaperActionMenu } from '@shared/ui-kit';

import type { AssignPeoplePermissionsEnum } from '@shared/enums/assignPeoplePermissions.enum';
import type { PaperActionMenuItemModel } from '@shared/models/paperActionMenuItem.model';

type AssignPeoplePermissionsMenuProps = {
  selectedPermissionsItem: PaperActionMenuItemModel & { id: AssignPeoplePermissionsEnum };
  isHideChangePermissionPopover?: boolean;
  menu: {
    item: PaperActionMenuItemModel;
    callback: () => void;
    disableCallback?: () => void;
    isDisabled?: boolean;
    tooltipTitle?: string;
  }[];
};
export const AssignPeoplePermissionsMenu: FC<AssignPeoplePermissionsMenuProps> = ({
  menu,
  selectedPermissionsItem,
  isHideChangePermissionPopover,
}) => {
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);
  const theme = useTheme();
  return isHideChangePermissionPopover ? (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        svg: { width: '16px', height: '16px', path: { fill: theme.palette.case.neutral.n500 } },
      }}
    >
      <Typography sx={{ m: '0 6px', color: theme.palette.case.neutral.n500 }} variant="t14r">
        {selectedPermissionsItem.label}
      </Typography>
    </Box>
  ) : (
    <PaperActionMenu
      isSmall
      onChangeMenuState={setIsOpenMenu}
      activeItem={selectedPermissionsItem.id}
      menuList={menu}
    >
      <Box
        sx={{
          display: 'flex',
          cursor: 'pointer',
          alignItems: 'center',
          svg: { width: '16px', height: '16px', path: { fill: theme.palette.case.neutral.n500 } },
        }}
      >
        <Typography sx={{ m: '0 6px', color: theme.palette.case.neutral.n500 }} variant="t14r">
          {selectedPermissionsItem.label}
        </Typography>

        <Box
          sx={{
            svg: {
              transform: isOpenMenu ? 'rotate(180deg)' : '',
              transition: '0.3s',
            },
          }}
        >
          <ArrowDownSmallIcon />
        </Box>
      </Box>
    </PaperActionMenu>
  );
};
